export default __webpack_public_path__ + "static/media/success-circle-green.1381d8cc.svg";